import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { emptyString, surveyQuestionsConstants } from "../../../constants";

const ArchiveButton = (props) => {
  const { isDisabled, questionText, onClick, index } = props;

  const [tooltipOpen, setTooltipOpen] = useState(false);

  //Toggle tooltip
  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <div
      className={`d-flex ${
        isDisabled ||
        questionText === surveyQuestionsConstants.NPS_QUESTION ||
        questionText === surveyQuestionsConstants.NPS_TEXT_QUESTION
          ? "d-none"
          : emptyString
      }`}
    >
      <FontAwesomeIcon
        size="lg"
        title="Archive"
        icon={faArchive}
        onClick={onClick}
        id={`tooltip-${index}`}
        data-testid="archived-icon"
        className="pointer me-3 text-white bg-dark p-2 rounded-pill ms-1"
      />
      <Tooltip
        flip={true}
        autohide={true}
        toggle={toggle}
        placement="auto"
        isOpen={tooltipOpen}
        target={`tooltip-${index}`}
        popperClassName="disable-link"
      >
        Archive
      </Tooltip>
    </div>
  );
};

export default ArchiveButton;
